module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/babel-runtime/regenerator/index.js
// module id = 38
// module chunks = 99